import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { rolesQueryOptions } from '../../../features/admin/queries'
import { NewUserPage } from '../../../features/admin/user-pages'

export const Route = createFileRoute('/_app/users/new')({
  staticData: { crumb: 'userNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'users.manage'),
  loader: ({ context }) => {
    // Warm the role picker; the form does not wait for it.
    if (context.session.permissions.includes('roles.read')) {
      void context.queryClient.prefetchQuery(rolesQueryOptions)
    }
  },
  component: NewUserPage,
})
